import React from 'react'
import PropTypes from 'prop-types'
import Tag from '../Tag'

const TagBlackFeirao = ({ width, height }) => (
  <Tag
    id="TagVehicleBlackFair"
    src="/assets/img/blackfeirao/Card - 90x13.png"
    name="Black Feirão"
    width={width}
    height={height}
  />
)

Tag.defaultProps = {
  width: '84px',
  height: '23px',
}

Tag.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
}

export default TagBlackFeirao
